<template>
  <a-spin tip="加载中..." :spinning="loading">
  <div class="center-box">

      <div class="searchBox">
          <a-space  class=" mr-10">
              <a-input class="keyword"  allowClear v-model:value="queryParams.searchKey"  @pressEnter="changePage"
                  placeholder="请输入关键字" />
          </a-space>
          <a-button  type="default" @click="changePage">查询</a-button>
      </div>

      <a-table :data-source="waylinesData.data" align="center" class="mt10" :pagination="paginationProp" row-key="id"  @change="refreshData">
              <a-table-column  align="center" key="name" title="航线名称" data-index="name" />
              <a-table-column  align="center" key="payload_model_keys" title="负载" data-index="payload_model_keys" >
                <template #default="{ record }">
                    {{ record.payload_model_keys.toString() }}
                  </template>
                </a-table-column>
              <a-table-column  align="center" key="update_time" title="更新时间" data-index="update_time" >
                <template #default="{record}">
                    {{ moment(record.update_time).format('YYYY-MM-DD HH:mm:ss') }}
                  </template>
              </a-table-column>
              <a-table-column  align="center" key="active" title="操作" >
                <template #default="{record}">
                  <a-button type="text" @click="openBinding(record)">绑定算法</a-button>
                </template>
              </a-table-column>
      </a-table>
      <a-modal
          v-model:open="isOpenAlgorithm"
          width="fit-content"
          style="min-height:40vh ;"
          :maskClosable="false"
          title="算法模型添加"
          >
        <div style="padding:  0;" class="cf">
          <div class="flex-display flex-justify-between flex-align-center mb10">
            <div></div>
            <a-button class="ant-btn-secondary" @click="addModel">添加模型</a-button>
          </div>
          <!-- 查询返回字段对应：跳帧数量→skip_frame，推送频率→push_frequency，置信度→conf_threshold -->
          <a-space class="mr-20">
            <span>跳帧数量:</span>
              <a-input-number v-model:value="skipFrame" :min="1"/>帧
          </a-space>
          <a-space class="mr-20">
            <span>推送频率:</span>
              <a-input-number v-model:value="pushFrequency" :min="1"/>秒
          </a-space>
          <a-space  class="mr-20">
            <span>置信度:</span>
              <a-input-number v-model:value="confThreshold" :min="0.01" :max="0.99" :step="0.01"/>
          </a-space>
          <a-space>
            <span>启用AI盒子:</span>
            <a-checkbox v-model:checked="isGdd"></a-checkbox>
          </a-space>
          <template v-if="taskList.data.length">
            <a-table
              class="mt20 algorithm-binding-table"
              :data-source="taskList.data"
              :row-key="(_: any, i: number) => i"
              :pagination="false"
              size="middle"
            >
              <a-table-column title="模型名称" align="center" width="160">
                <template #default="{ record }">
                  <a-select
                    ref="select"
                    v-model:value="record.model_no"
                    :disabled="record.taskNo"
                    placeholder="请选择模型"
                    style="width: 140px"
                  >
                    <a-select-option v-for="item in modelList" :key="item.name" :value="item.name" :title="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                </template>
              </a-table-column>
              <a-table-column title="开始算法航点" align="center" width="120">
                <template #default="{ record }">
                  <a-select
                    v-model:value="record.start_point_index"
                    style="width: 100px"
                  >
                    <a-select-option v-for="item in waylineList" :key="item" :value="item">{{ item }}</a-select-option>
                  </a-select>
                </template>
              </a-table-column>
              <a-table-column title="结束算法航点" align="center" width="120">
                <template #default="{ record }">
                  <a-select
                    v-model:value="record.end_point_index"
                    style="width: 100px"
                  >
                    <a-select-option v-for="item in waylineList" :key="item" :value="item">{{ item }}</a-select-option>
                  </a-select>
                </template>
              </a-table-column>
              <a-table-column title="动作绑定" align="center" width="180">
                <template #default="{ record }">
                  <a-select
                    @change="(v: []) => changeAction(v, record)"
                    v-model:value="record.actions"
                    mode="multiple"
                    placeholder="请选择动作"
                    style="width: 160px"
                  >
                    <a-select-option v-for="item in aiList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                  </a-select>
                </template>
              </a-table-column>
              <a-table-column title="选择音频" align="center" width="160">
                <template #default="{ record }">
                  <a-select
                    :disabled="!record.actions?.includes('VOICE')"
                    v-model:value="record.file_id"
                    placeholder="请选择音频"
                    style="width: 140px"
                  >
                    <a-select-option v-for="item in audioList" :key="item.file_id" :value="item.file_id">{{ item.file_title }}</a-select-option>
                  </a-select>
                </template>
              </a-table-column>
              <a-table-column title="操作" align="center" width="80">
                <template #default="{ record, index }">
                  <a-button type="text" danger @click="deleteModel(index, record.id,record)">
                    <template #icon>
                      <DeleteOutlined />
                    </template>
                  </a-button>
                </template>
              </a-table-column>
            </a-table>
          </template>
        </div>
        <template #footer>
          <a-button key="back" class="ant-btn-secondary" @click="cancelBinding">取消</a-button>
          <a-button key="submit" type="default" :loading="isBindingLoading" @click="bindingAlgorithm">确定</a-button>
        </template>
        </a-modal>

  </div>
</a-spin>
</template>

<script lang="ts" setup>
import { ref, onMounted, reactive, computed } from 'vue'
import { getWaylineFiles, getWaylineLngLat } from '/@/api/wayline'
import { ELocalStorageKey } from '/@/types'
import { WaylineFile, taskListType } from '/@/types/wayline'
import {
  getAlgorithmModelListPageVo,
  bindingAiAlgorithm,
  getWayLineAiBindingDetail,
  getAudioFileList,
  getRouteAlgorithmModel,
  deleteRouteAlgorithmModel
} from '/@/api/manage'
import coordtransform from 'coordtransform'// 坐标转换
import moment from 'moment'
import { message, Pagination } from 'ant-design-vue'
import {
  DeleteOutlined
} from '@ant-design/icons-vue'
const queryParams = ref({
  page_num: 1,
  page_size: 10,
  algorithm_type: null,
  searchKey: null
})
const paginationProp = reactive({
  showQuickJumper: false,
  showSizeChanger: false,
  page_size: 10,
  current: 1,
  total: 0
})
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const waylinesData = reactive({
  data: [] as WaylineFile[],
})
const taskList = reactive({
  data: [] as taskListType[],
})
const isOpenAlgorithm = ref(false)
const modelList = ref([])
const waylineInfo = ref()
const waylineList = ref([])
const audioList = ref([])
const aiList = ref([
  { id: 'VOICE', name: '语音喊话' },
  { id: 'PHOTO', name: '拍照' },
  { id: 'FLASH', name: '红蓝爆闪' },
  { id: 'IR', name: '探照灯' },
])
const loading = ref(false)
// 跳帧数量→skip_frame，推送频率→push_frequency，置信度→conf_threshold
const pushFrequency = ref(15)
const skipFrame = ref(3)
const confThreshold = ref(0.5)
const algorithm_source = ref<'dksl' | 'gdd'>('dksl')
const isGdd = computed({
  get: () => algorithm_source.value === 'gdd',
  set: (val: boolean) => {
    algorithm_source.value = val ? 'gdd' : 'dksl'
  }
})
const isBindingLoading = ref(false)
onMounted(() => {
  getList()
  getModelList()
  getAudio()
})
function getAudio () {
  getAudioFileList(workspaceId, { page: 1, page_size: 999 }).then(res => {
    if (res.code === 0) {
      audioList.value = res.data.list
    }
  })
}
function changeAction (value:string[], taskItem:object) {
  if (!value.includes('VOICE') && taskItem.file_id) {
    taskItem.file_id = ''
  }
}
function cancelBinding () {
  isOpenAlgorithm.value = false
  taskList.data = []
  skipFrame.value = 3
  pushFrequency.value = 15
  confThreshold.value = 0.5
}
async function deleteModel (index:number, id:number, record:any) {
  // 如果没有模型信息（新增但未绑定到后端），仅前端删除
  if (!Array.isArray(record?.modelInfo) || record.modelInfo.length === 0) {
    taskList.data.splice(index, 1)
    return
  }

  // 若没有必要的字段，直接做前端删除兜底
  if (!record?.start_point_index || !record?.end_point_index || !record?.id) {
    taskList.data.splice(index, 1)
    return
  }

  try {
    const res = await deleteRouteAlgorithmModel({
      flyLineId: String(record.id),
      startPointIndex: record.start_point_index,
      endPointIndex: record.end_point_index
    })
    if (res.code === 0) {
      taskList.data.splice(index, 1)
      message.success('删除成功')
    } else {
      message.error(res?.message || '删除失败')
    }
  } catch (e) {
    message.error('删除失败')
  }
}
function getModelList () {
  getAlgorithmModelListPageVo({
    page: 1,
    size: 99,
    // algorithm_type: null,
    name: '',
    // workspace_id: workspaceId
  }).then(res => {
    if (res.code === 0) {
      modelList.value = res.data.list
    }
  })
}
/* function getBindingAlgorithm (flyLineId:string) {
  const userId = localStorage.getItem(ELocalStorageKey.UserId)
  taskList.data = []
  getWayLineAiBindingDetail({
    // user_id: userId || '',
    fly_line_id: flyLineId
  }).then(res => {
    if (res.code === 0) {
      if (res.data.list.length > 0) {
        confThreshold.value = res.data.list[0].conf_threshold
        pushFrequency.value = res.data.list[0].push_frequency
        algorithm_source.value = res.data.list[0].algorithm_source
        skipFrame.value = res.data.list[0].skip_frame
        res.data.list.forEach(item => {
          taskList.data.push({
            model_no: item.model_no,
            modelInfo: [],
            start_point_index: item.start_point_index,
            end_point_index: item.end_point_index,
            actions: JSON.parse(item.actions ?? '[]') ?? [],
            file_id: item.file_id,
          })
        })
      }
    }
  })
} */
function bindingAlgorithm () {
  if (!taskList.data?.length) {
    message.warning('请添加模型')
    return
  }
  const userId = localStorage.getItem(ELocalStorageKey.UserId)
  const list:any = []
  for (const item of taskList.data) {
    item.modelInfo = []
    for (const elModel of modelList.value) {
      if (item.model_no === elModel.name) {
        item.modelInfo.push({
          model_name: elModel.name,
          model_no: elModel.name,
          algorithm_source: algorithm_source.value
        })
      }
    }
    list.push({
      start_point_index: item.start_point_index,
      end_point_index: item.end_point_index,
      model_list: item.modelInfo,
      actions: item.actions,
      file_id: item.file_id,
    })
    if (item.actions?.includes('VOICE') && !item.file_id) {
      message.warning('请选择音频文件')
      return
    }
  }
  isBindingLoading.value = true
  // 提交字段与接口一致：跳帧数量→skip_frame，推送频率→push_frequency，置信度→conf_threshold
  bindingAiAlgorithm({
    user_id: userId,
    fly_line_id: waylineInfo.value.id,
    skip_frame: skipFrame.value,
    push_frequency: pushFrequency.value,
    conf_threshold: confThreshold.value,
    waypoint_algorithm_list: list
  }).then(res => {
    if (res.code === 0) {
      isOpenAlgorithm.value = false
      taskList.data = []
      skipFrame.value = 3
      pushFrequency.value = 15
      confThreshold.value = 0.5
      message.success('绑定算法成功')
    }
  }).finally(() => {
    isBindingLoading.value = false
  })
}
function addModel () {
  taskList.data.push({
    id: waylineInfo.value?.id ?? '',
    model_no: '',
    modelInfo: [],
    start_point_index: 1,
    end_point_index: waylineList.value.length
  })
}
function openBinding (wayline:any) {
  loading.value = true
  waylineInfo.value = wayline
  taskList.data = []
  // 并行请求：航线航点 + 已绑定算法模型
  Promise.all([
    getWaylineLngLat(workspaceId, waylineInfo.value.id),
    getRouteAlgorithmModel(wayline.id)
  ]).then(([lngLatRes, algorithmRes]) => {
    if (lngLatRes.code !== 0) {
      loading.value = false
      return
    }
    waylineList.value = []
    if (lngLatRes.data.waylines?.length > 0) {
      const num = lngLatRes.data.waylines.length
      for (let i = 1; i <= num; i++) {
        waylineList.value.push(i)
      }
    }
    if (algorithmRes?.code === 0 && algorithmRes?.data) {
      const data = algorithmRes.data
      // 查询返回字段与表单一一对应：跳帧数量→skip_frame，推送频率→push_frequency，置信度→conf_threshold
      if (data.skip_frame != null) skipFrame.value = data.skip_frame
      if (data.push_frequency != null) pushFrequency.value = data.push_frequency
      if (data.conf_threshold != null) confThreshold.value = data.conf_threshold
      if (data.algorithm_source != null) algorithm_source.value = data.algorithm_source === 'gdd' ? 'gdd' : 'dksl'
      const list = data?.waypoint_algorithm_list ?? []
      // 使用接口返回的 fly_line_id 作为表格行的 id，保证与后端一致
      const flyLineId = data.fly_line_id ?? waylineInfo.value?.id ?? ''
      if (list.length > 0) {
        const rows: any[] = []
        let actionsArr: any[] = []
        for (const item of list) {
          if (Array.isArray(item.actions)) {
            actionsArr = item.actions
          } else if (item.actions && item.actions !== 'null') {
            try {
              actionsArr = JSON.parse(item.actions) ?? []
            } catch (_) {
              actionsArr = []
            }
          } else {
            actionsArr = []
          }
          const models = item.model_list ?? []
          const start = item.start_point_index ?? 1
          const end = item.end_point_index ?? waylineList.value.length
          if (models.length > 0) {
            for (const model of models) {
              // 优先用 model_name，其次 model_no，保证模型名称与接口一致
              const modelName = (model?.model_name ?? model?.model_no ?? '').trim()
              rows.push({
                id: flyLineId,
                taskNo: item.taskNo,
                model_no: modelName,
                modelInfo: modelName ? [{ model_name: modelName, model_no: model?.model_no ?? modelName, algorithm_source: algorithm_source.value }] : [],
                start_point_index: start,
                end_point_index: end,
                actions: [...actionsArr],
                file_id: item.file_id ?? ''
              })
            }
          } else {
            rows.push({
              id: flyLineId,
              taskNo: item.taskNo,
              model_no: '',
              modelInfo: [],
              start_point_index: start,
              end_point_index: end,
              actions: actionsArr,
              file_id: item.file_id ?? ''
            })
          }
        }
        taskList.data = rows
      }
    }
    loading.value = false
    isOpenAlgorithm.value = true
  }).catch(() => {
    loading.value = false
  })
}
function changePage () {
  queryParams.value.page_num = 1
  getList()
}
function refreshData (page:any) {
  queryParams.value.page_num = page.current
  getList()
}
function getList () {
  getWaylineFiles(workspaceId, {
    page: queryParams.value.page_num,
    page_size: queryParams.value.page_size,
    order_by: 'update_time desc',
  })
    .then((res) => {
      if (res.code !== 0) {
        return
      }
      waylinesData.data = [...res.data.list]
      paginationProp.total = res.data.pagination.total
      paginationProp.current = res.data.pagination.page
    })
}
</script>

<style lang="scss" scoped>
/* 算法绑定表格样式优化 */
.algorithm-binding-table {
  margin-top: 20px;

  /* 表头样式 */
  :deep(.ant-table-thead > tr > th) {
    background-color: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.85);
    font-weight: 500;
    padding: 12px 8px;
  }

  /* 表格单元格样式 */
  :deep(.ant-table-tbody > tr > td) {
    padding: 12px 8px;
  }

  /* 取消行 hover 高亮 */
  :deep(.ant-table-tbody > tr.ant-table-row:hover > td) {
    background: transparent !important;
  }

  /* 下拉选择框样式 */
  :deep(.ant-select-selector) {
    background-color: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.12);
    color: #fff;
  }

  :deep(.ant-select-selection-placeholder) {
    color: rgba(255, 255, 255, 0.4);
  }

  /* 禁用状态的下拉框 */
  :deep(.ant-select-disabled .ant-select-selector) {
    background-color: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.3);
  }
}
</style>
